<template>
  <div v-if="value !== null && value !== undefined" class="c-metadata-badge inline-block">
    <CTag class="flex gap-1 bg-primary6 color-text" size="small">
      {{ label }}
      <template v-if="!isBooleanTrue">
        :
        <span v-if="highlightText" v-html="highlight(String(value), highlightText)" />
        <span v-else>{{ value }}</span>
      </template>
    </CTag>
  </div>
</template>

<script setup lang="ts">
import CTag from '@lib/components/CTag/CTag.vue'
import { highlight } from '@lib/util/string'
import { computed } from 'vue'

const props = withDefaults(
  defineProps<{
    label: string
    value: string | boolean | number | null | undefined
    highlightText?: string
  }>(),
  {
    highlightText: '',
  },
)

const isBooleanTrue = computed(() => {
  return typeof props.value === 'boolean' && props.value === true
})
</script>
